import React from "react";
import { Grid, Typography } from "@material-ui/core";

export default function PaymentDueToday(props) {
    const {ePayFee, currentMonthPayment, totalDueToday, proRatedAmount} = props;
    const totalMonths = currentMonthPayment/proRatedAmount;
    return (<>
                <Grid container>
                    <Grid item xs={12} md={6}>
                        <Typography component="strong" variant="caption" className="floatLeft mb0">Pro-Rated Monthly
                            Contribution Amount </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography component="strong" variant="caption" align="right"
                                    className="floatRight w100 mb0">${currentMonthPayment}</Typography>
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <Typography variant="caption" className="floatLeft w100 ">Your monthly payments begin today but
                            we need to collect all previous months from
                            your last
                            anniversary date (XX/XX/XXXX) until today to be applied to those months for next years
                            contribution
                            since you are always paying for next year in advance. If you have questions, please contact
                            your
                            advisor.</Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Typography align="right" variant="caption" className="floatRight w100">({proRatedAmount}/mo X {totalMonths} previous
                            months)</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography component="strong" variant="caption" className="floatLeft mb0">ePay Processing
                            Fee</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography component="strong" variant="caption" align="right"
                                    className="floatRight w100 mb0">${ePayFee}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <span className="hLine" />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" component="strong" className="floatLeft w100 mb0">Total Due
                            Today</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" component="strong" align="right"
                                    className="floatRight w100 mb0">${totalDueToday}</Typography>
                    </Grid>
                </Grid>
            </>
    );
};
